const checkPosType = (name = "") => {
    return /(restaurant|hotel)/i.test(name);
  };
  
  export default checkPosType;
  